module.exports = __webpack_public_path__ + "static/layering-stackorder-21a3d4085ef645ef86435a36c4f6eb7c.gif";